interface LoadingSkeletonProps {
  count?: number
}

export default function LoadingSkeleton({ count = 6 }: LoadingSkeletonProps) {
  return (
    <>
      {Array.from({ length: count }, (_, i) => (
        <div
          key={i}
          className="aspect-square rounded-xl shimmer border border-border relative overflow-hidden"
        >
          <div className="scan-beam" />
        </div>
      ))}
    </>
  )
}
